import React from 'react'
import annualCostsByAge from '../../../../calculations/annualCostsByAge'
import Chart from './Chart'

export default ({ form }) => (
  <Chart
    yAxisLabel={[{ text: 'Annual cost', x: -25 }]}
    data={annualCostsByAge(form)}
    form={form}
  />
)
